import { Link } from 'react-router-dom';

import Button from '@/components/common/Button/Button';
import MotionDiv from '@/components/common/Motion/MotionDiv';
import IncomeVisual from '@assets/visuals/income.webp'

interface Props {
  title: string;
  className?: string;
  to: string;
  buttonVariant?: 'primary' | 'secondary';
  text?: string;
}

const IncomeWidget = ({
  title,
  className = '',
  to,
  buttonVariant = 'secondary',
  text
}: Props) => {
  return (
    <MotionDiv delay={0.2} className='tour-recommendation-widget'>
      <Link to={to} className={`relative flex flex-col bg-zinc-100 rounded-2xl p-4 flex items-start overflow-hidden ${className}`}>
        <img
          src={IncomeVisual}
          className={`h-[12rem] absolute top-0 right-0 transition-transform duration-300 ease-out`}
        />
        <p className="font-semibold text-[1.125rem] text-[#000] w-[9.875rem] mb-6">
          {title}
        </p>
        <Button variant={buttonVariant}
          className='py-[0.37rem] px-[1rem] flex'
        >
          <span className='text-sm'>{text}</span>
        </Button>
      </Link>
    </MotionDiv>
  );
};

export default IncomeWidget;